export default "__VITE_ASSET__DIUXx1SE__"